const DEFAULT_DATE_FORMAT = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
} as Intl.DateTimeFormatOptions;

export { DEFAULT_DATE_FORMAT };
